var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg menu",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71,5.14H30.29A1.76,1.76,0,0,1,32,6.86h0a1.76,1.76,0,0,1-1.71,1.71H1.71A1.76,1.76,0,0,1,0,6.86H0A1.76,1.76,0,0,1,1.71,5.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71,14.29H30.29A1.76,1.76,0,0,1,32,16h0a1.76,1.76,0,0,1-1.71,1.71H1.71A1.76,1.76,0,0,1,0,16H0A1.76,1.76,0,0,1,1.71,14.29Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71,23.43H30.29A1.76,1.76,0,0,1,32,25.14h0a1.76,1.76,0,0,1-1.71,1.72H1.71A1.76,1.76,0,0,1,0,25.14H0A1.76,1.76,0,0,1,1.71,23.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.ef76901b8822d627c32c25b34fc9be7d.svg";
export { ForwardRef as ReactComponent };